import styled from 'styled-components'

export const CardDetails = styled.span`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-top: auto;
	padding-top: 16px;
`
